/* eslint-disable complexity */
import React, { useRef, useEffect, useState, useContext } from "react";
import { Schedule, CalendarType, Agent, UserType, Scope } from "@/api/calendar";
import dayjs, { Dayjs } from "dayjs";
import "./index.less";
import { getRealColor, assignTime, getScheduleTimeForTooltip } from "@/components/Calendars/utils";
import SchdeulePopover from "@/components/Calendars/Schedule/SchdeulePopover";
import { getTypeImage, getDefaultColor } from "@/components/Calendars/utils/getTypeImage";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { message, Tooltip } from "antd";
import { DragType } from "@/components/Calendars/Enums";
import { connect } from "dvajs";
import { UserModel } from "@/models/user";
import { ScheduleDetailFrom } from "@/components/Calendars/Schedule/Detail";
import { analysisLog } from "@/utils/logAnalytics";
import bus from "@/utils/bus";

function ViewScheduleItem({
  schedule,
  styles,
  currentTime,
  userData,
  doubleModifySchedule,
  changeScheduleInfoDraw,
  handleMouseDown
}: {
  schedule: Schedule;
  styles: React.CSSProperties;
  currentTime: Dayjs;
  userData: UserModel;
  doubleModifySchedule: Function;
  changeScheduleInfoDraw: (payload: {
    visible: boolean;
    scheduleId: string;
    selectedScheduleTime: Dayjs;
    from: number;
    openTime: Dayjs;
    isBusy: number;
    busyRealName: string;
    beginTime: Dayjs;
    endTime: Dayjs;
  }) => void;
  handleMouseDown?: Function;
}) {
  // const { authInfo } = useContext<GlobalContextConfig>(GlobalContext);
  let scheduleStart = schedule.scheduleBeginTime || dayjs(schedule.beginTime);
  let scheduleEnd = schedule.scheduleEndTime || dayjs(schedule.endTime);
  const { t } = useTranslation("calendar");
  const timePast = scheduleEnd.isBefore(dayjs());
  const start = scheduleStart.format("HH:mm");
  const end = scheduleEnd.format("HH:mm");
  const color = getRealColor(schedule.color || schedule.calendarInfo?.color);
  // const backgroundColor = `${color}33`;
  schedule.color = schedule.color || getDefaultColor();
  const showTime = (scheduleEnd.unix() - scheduleStart.unix()) % (24 * 60 * 60) > 15 * 60;
  const itemRef: any = useRef(null);
  const [timeVisible, setTimeVisible] = useState(true);
  const hasMessage = useRef(false); // 是否已经显示了不允许拖拽的提示false没有true有
  const disableClick = useRef(false); // 是否可点击
  let calenderColor = color;
  if (schedule.calendarInfo) {
    calenderColor = schedule.calendarInfo.color;
  }
  const [hover, setHover] = useState(false);
  const backgroundColor = hover
    ? `${schedule.comeFrom === 5 ? color + "66" : "rgba(222,237,255,1)"}`
    : `${schedule.comeFrom === 5 ? color + "26" : "#FFFFFF"}`;
  // useEffect(() => {
  //     if (itemRef.current && itemRef.current.clientWidth < 86) {
  //         setTimeVisible(false);
  //     }
  // }, []);
  const count = useRef<number>(0);
  const timer = useRef<any>(null);
  const disableClickHandle = (isClick: boolean) => {
    disableClick.current = isClick;
  };
  useEffect(() => {
    let handelResize = () => {
      if (itemRef.current && itemRef.current.clientWidth < 86) {
        setTimeVisible(false);
      } else {
        setTimeVisible(true);
      }
    };
    const throttleHandleResize = _.throttle(handelResize, 200);
    handelResize();
    window.addEventListener("resize", throttleHandleResize);
    bus.on("calendar:scheduleItem:disableClick", disableClickHandle);
    return () => {
      window.removeEventListener("resize", throttleHandleResize);
      bus.off("calendar:scheduleItem:disableClick", disableClickHandle);
    };
  }, []);
  const doubleClickFun = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    analysisLog("xtbg_calhome_1640073907694", "63");
    const isCalendarAgent = schedule.isCalendarAgent === Agent.AgentAllowed;
    const isCreator = userData?.userId === schedule.userId;
    if (!((isCalendarAgent || isCreator) && schedule.archive !== 0)) {
      // move同一个元素的时候容易产生多个提示 通过key值去重又容易引起message不消失问题
      // ant 4.2的版本没有根据key值destroy的方法 所以通过hasMessage去重
      if (hasMessage.current) return;
      hasMessage.current = true;
      return message.warning(t("no permission to modify the schedule")).then(
        () => {
          hasMessage.current = false;
          return;
        },
        () => {
          hasMessage.current = false;
          return;
        }
      );
    }
    doubleModifySchedule(schedule);
  };
  const onVisibleChange = (item: any) => {
    changeScheduleInfoDraw({
      visible: true,
      scheduleId: item.scheduleId,
      selectedScheduleTime: currentTime || dayjs(), // 选中的时间
      from: ScheduleDetailFrom.Calendar,
      openTime: dayjs(),
      isBusy: item.isBusy,
      busyRealName: item.realName,
      beginTime: item.scheduleBeginTime,
      endTime: item.scheduleEndTime
    });
  };
  // 判断点击事件
  const determineClickEvents = (e: any) => {
    e.stopPropagation();
    count.current++;
    if (!timer.current) {
      timer.current = setTimeout(function () {
        if (count.current > 1) {
          // 双击
          // move事件一开始屏蔽单击或双击
          if (!disableClick.current) {
            doubleClickFun?.(e);
          }
          clearTimeout(timer.current);
          timer.current = null;
        } else {
          // 单击
          // move事件一开始屏蔽单击或双击
          if (!disableClick.current) {
            onVisibleChange(schedule);
          }
          clearTimeout(timer.current);
          timer.current = null;
        }
        count.current = 0;
      }, 500);
    }
  };
  return (
    <SchdeulePopover
      item={schedule}
      key={schedule.scheduleId}
      selectedScheduleTime={currentTime}
      // disable={schedule.isBusy}
    >
      <Tooltip
        overlayClassName="calendar-view-title-tooltip"
        title={`${schedule.isBusy ? schedule.realName + " " + t("busy") : schedule.title}${
          " " + getScheduleTimeForTooltip(schedule, false, currentTime, t)
        }`}
      >
        <div
          className={`view-schedule-item ${timePast ? "schedule-timepast" : ""}`}
          style={{
            backgroundColor: backgroundColor,
            color: "#000000",
            ...styles
          }}
          onMouseEnter={(e: any) => {
            setHover(true);
          }}
          onMouseLeave={() => {
            setHover(false);
          }}
          onClick={(e: any) => {
            // console.log("scheduleitem click ", disableClick.current);
            // 由于每个schedule item上既有单击事件 又有双击事件 会发生事件冲突
            // 所以先通过阻止冒泡 屏蔽上层元素的单击click事件和双击拖拽事件 再通过点击计数器判定是双击还是单击
            // 如果是单击 重新实现一变原有的单击查看详情功能
            // move事件一开始屏蔽单击或双击
            e.persist();
            e.stopPropagation();
            if (disableClick.current) return;
            determineClickEvents(e);
          }}
          onDoubleClick={(e: any) => {
            e.persist();
            e.stopPropagation();
            // move事件一开始屏蔽单击或双击
            if (disableClick.current) return;
          }}
          onMouseDown={(e: any) => {
            e.stopPropagation();
            handleMouseDown?.(e, DragType.DRAGBLOCKEDIT, schedule, itemRef.current);
          }}
          ref={itemRef}
        >
          <div
            className="pre-circle"
            style={{
              backgroundImage: `url(${getTypeImage(schedule.color)})`
            }}
          />
          <div className="view-schedule-item-content">
            <div className="title">
              {schedule.calendarType !== CalendarType.PublicType &&
              schedule.comeFrom !== 1 &&
              schedule.comeFrom !== 4 &&
              schedule.realName
                ? schedule.realName + " "
                : ""}
              {schedule.isBusy ? t("busy") : schedule.title}
            </div>
            {/* {!schedule.isBusy && showTime && timeVisible && ( */}
            <div className="time">{`${start}-${end}`}</div>
            {/* <div className="time">{`${start}-${end}`}</div> */}
          </div>
        </div>
      </Tooltip>
    </SchdeulePopover>
  );
}

function mapStateToProps({ user }: any) {
  return {
    userData: user.userData.user
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changeScheduleInfoDraw: (payload: {
      visible: boolean;
      scheduleId: string;
      selectedScheduleTime: Dayjs;
      from: number;
      openTime: Dayjs;
      isBusy: number;
      busyRealName: string;
      beginTime: Dayjs;
      endTime: Dayjs;
    }) =>
      dispatch({
        type: "calendar/changeScheduleInfoDraw",
        payload
      })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewScheduleItem);
